import { IconWarning, colors, getSpacing, spacing } from '@cabonline/ui-shared';
import { Text, TextProps } from '../text';
import styled from '@emotion/styled';
import { FC, PropsWithChildren } from 'react';

const StyledWrapper = styled.div<{ marginBottom?: keyof typeof spacing }>`
  display: flex;
  align-items: center;
  margin-bottom: ${(p) => p.marginBottom && getSpacing(p.marginBottom)};
  gap: ${getSpacing('xxs')};
`;

const StyledIcon = styled(IconWarning)`
  min-width: 24px;
`;

interface ErrorTextProps extends Omit<TextProps, 'color'>, PropsWithChildren {
  darkMode?: boolean;
}

export const ErrorText: FC<ErrorTextProps> = ({
  children,
  marginBottom,
  darkMode,
  ...rest
}) => {
  const color = darkMode ? colors.lightRed : colors.red;
  return (
    <StyledWrapper marginBottom={marginBottom}>
      <StyledIcon aria-hidden color={color} />
      <Text {...rest} color={color}>
        {children}
      </Text>
    </StyledWrapper>
  );
};
